import { render } from "./App.vue?vue&type=template&id=349ed947"
const script = {}

import "./App.vue?vue&type=style&index=0&id=349ed947&lang=scss"

import exportComponent from "D:\\Healink\\website\\healink-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__